"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _gridConfig = require("./gridConfig");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridHeadItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(GridHeadItem, _React$PureComponent);

  var _super = _createSuper(GridHeadItem);

  function GridHeadItem() {
    var _this;

    _classCallCheck(this, GridHeadItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleHeadClick", function () {
      var _this$props = _this.props,
          field = _this$props.field,
          item = _this$props.item,
          onSort = _this$props.onSort;
      onSort(field, item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizerClick", function () {
      var _this$props2 = _this.props,
          field = _this$props2.field,
          onMaximaze = _this$props2.onMaximaze;
      onMaximaze(field);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props3 = _this.props,
          t = _this$props3.t,
          field = _this$props3.field,
          lastField = _this$props3.lastField,
          _this$props3$item = _this$props3.item,
          name = _this$props3$item.name,
          hidden = _this$props3$item.hidden,
          classWidth = _this$props3$item.classWidth,
          notDraggable = _this$props3$item.notDraggable,
          width = _this$props3$item.width,
          sort = _this$props3.sort,
          dropHighlight = _this$props3.dropHighlight,
          onDragStart = _this$props3.onDragStart,
          onDragEnter = _this$props3.onDragEnter,
          onDragOver = _this$props3.onDragOver,
          onDragEnd = _this$props3.onDragEnd,
          onStartResize = _this$props3.onStartResize,
          resizing = _this$props3.resizing,
          forceWidth = _this$props3.forceWidth,
          fixedWidth = _this$props3.fixedWidth;
      if (hidden) return null;
      var isSorted = sort.field === field; // temparary solution

      var sortIconClass = sort.order === _gridConfig.ASC ? _gridConfig.UP : _gridConfig.DOWN;
      var mainClass = field !== lastField && classWidth ? classWidth : '';
      var thClassName = (0, _classnames["default"])('head-cell', "grid-cell-".concat(mainClass), {
        'droppable-cell-hover': dropHighlight,
        resizing: resizing
      });
      var forcedWidthStyle = (0, _helpers.getWidthStyles)(forceWidth || fixedWidth || width);
      return /*#__PURE__*/_react["default"].createElement("th", {
        title: t(name),
        "data-name": field,
        className: thClassName,
        draggable: !resizing && !notDraggable,
        onDragStart: onDragStart,
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragEnd: onDragEnd,
        style: forcedWidthStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "head-cell-content",
        onClick: _this.handleHeadClick
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "head-cell-text"
      }, t(name)), isSorted && sort.order && /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-sort-icon-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon-".concat(sortIconClass)
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        draggable: false,
        className: "head-cell-resizer",
        onMouseDown: onStartResize,
        onDoubleClick: _this.handleResizerClick
      }));
    });

    return _this;
  }

  return _createClass(GridHeadItem);
}(_react["default"].PureComponent);

exports["default"] = GridHeadItem;
GridHeadItem.propTypes = {
  t: _propTypes["default"].func.isRequired,
  field: _propTypes["default"].string.isRequired,
  lastField: _propTypes["default"].string.isRequired,
  item: _propTypes["default"].object.isRequired,
  sort: _propTypes["default"].object,
  dropHighlight: _propTypes["default"].bool,
  onDragStart: _propTypes["default"].func,
  onDragEnter: _propTypes["default"].func,
  onDragOver: _propTypes["default"].func,
  onDragEnd: _propTypes["default"].func,
  widthClassName: _propTypes["default"].string,
  onStartResize: _propTypes["default"].func.isRequired,
  forceWidth: _propTypes["default"].number,
  fixedWidth: _propTypes["default"].number,
  resizing: _propTypes["default"].bool,
  onSort: _propTypes["default"].func.isRequired,
  onMaximaze: _propTypes["default"].func,
  hidden: _propTypes["default"].bool
};